import {Injectable} from 'ng-metadata/core';
import {PushtoService} from "../pushto.service";
import {CMIntegrationService} from "../../../cm_integration.service";
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";

@Injectable()
export class EndNoteService {
    private popupWin: Window;

    constructor(private pushtoService: PushtoService,
                private cmIntegrationService: CMIntegrationService,
                private configurationUtil: ConfigurationUtil,
    ){

    }

    private cm_override_winpop(){
        return this.configurationUtil.getFeatureFlag('cm_override_winpop');
    }
    public endNoteAction(item, selectedIds){
        if(!this.cmIntegrationService.isEnabled() || !this.cm_override_winpop()){
            //in the campusM PI we do not want to open the window from the VE context as it runs in a webview iframe and fails
            this.popupWin = window.open('', "_blank") ;
        }

        let failedAction = angular.bind(this, this.failedPushtoAction);
        let successAction = angular.bind(this, this.successfullPushtoAction);
        let pushtoPromise = this.pushtoService.getServiceUrl([item], selectedIds, 'endnote');
        pushtoPromise.then((response)=>successAction(response), (response)=>failedAction(response));
    }




    private successfullPushtoAction(response) {

        let serviceUrl = response.data.serviceUrl;
//changing this requires testing on the campusM PI
        if(!this.cmIntegrationService.isEnabled() || !this.cm_override_winpop()) {
            this.popupWin.document.open();
            this.popupWin.document.write(`<html>
                                            <head>
                                                <link rel="stylesheet" type="text/css" href="style.css" />
                                                <meta http-equiv="refresh" content="1; url=${serviceUrl}" />
                                                </head>
                                                <body></body></html>`);
            this.popupWin.document.close();

            console.log("Endnote successfully sent");
        }
        else{
            //this will get overridden and handled in campusm (see cm_integrations.ts)
            window.open(serviceUrl, "_blank") ;
        }


        console.log("Endnote successfully sent");
    }

    private failedPushtoAction(response) {
        console.log("Endnote call failed");
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/endNoteAction/endNote.service.ts